import React from "react";
import InstallationsHistoryView from "../../../views/installations/history";

const InstallationsHistory = () => {
  return <InstallationsHistoryView />;
};

export default InstallationsHistory;
